import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const DocumentationInternationalStepConfig: StepConfig = {
    type: FormType.DOCUMENTATION_INTERNATIONAL
};
